import { css } from "@emotion/css";

import { fadeIn } from "../../core/styles/Animation";

export const vendorDataStyle = css`
    width: 50%;
`;

export const sectionStyle = css`
    overflow: hidden;
    ${fadeIn}

    & .sds-section-header {
        align-items: flex-end;
        min-height: 84px;
        padding-bottom: 24px;
    }
`;
